import angular from 'angular';

const componentOptions = {
    bindings: {
        bobOrder: '=',
        price: '=',
        modalInstance: '='
    },
    controllerAs: 'bobSummaryCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-bob-summary-view.html';
    }]
};


const componentInfo = {
    module: 'ib-bob-box-module',
    selector: 'ibBobSummary',
    inject: ['$scope', 'DatalayerUtilsService', 'AncillariesConstants'],
    required: ['']
};

export class ibBobSummary implements ng.IController {

    private modalInstance;
    public quanty = 0;
    public specialUser = false;
    private price;
    constructor (private $scope: angular.IScope, private DatalayerUtilsService: DatalayerUtilsService, private AncillariesConstants: AncillariesConstant) {

    }

    $onInit () {
    }

    /**
     * Emit event to parent for open modal of BoB
    */
    close = (): void => {
        this.trackingStep();
        this.modalInstance.dismiss('cancel');
    };

    trackingStep () {
        const price = this.price > 0 ? this.AncillariesConstants.DATALAYER_INFO.PAYMENT : this.AncillariesConstants.DATALAYER_INFO.FREE;
        this.DatalayerUtilsService.updateDatalayerEvents(this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB, this.AncillariesConstants.DATALAYER_INFO.STEP_TWO, this.AncillariesConstants.DATALAYER_INFO.FINALIZE + price, this.AncillariesConstants.DATALAYER_INFO.INTERACCION);
    }
}

try {
    const mod = angular.module(componentInfo.module);
    ibBobSummary.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBobSummary })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBobSummary.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBobSummary })
    );
}
